import enUS from './../../lang/en-US';

export default {
  lang: enUS,
  recaptcha: null,
  isoCountryCode: '',
  isLoading: false,
  hasCheckSession: false,
  showAccountLinkingNotice: false,
  isAccountDuplicated: false,
  allowAction: ['sign_in', 'sign_up'],
  signUpFormColumn: {},
  isAccountInputFixed: false,

  // SignUp
  countryId: '', // no use
  signUpErrMsg: '',
  signUpStep: 1,
  emailError: '',
  phoneError: '',

  // SignUp & SignIn
  phoneCode: '',
  phoneNumber: '',
  nationalNumber: '',
  emailAddr: '',
  isPasswordSet: false,
  isAccountPrefilled: false,
  prefilledAccount: '',
  supportAuthMethod: [],

  username: '',
  googleEmail: '',
  appleEmail: '',

  // SignIn
  isAbleToSignIn: true,
  isTwoFactor: false,
  signInErrMsg: '',
  signInStep: 1,
  signInType: '',

  // EmailVerification
  isVerificationSkip: false,
  skipEmailVerification: false,
  disableEmailVerification: false,
  isPaidAccount: '0',
  isEmailVerified: '0',
  emailVerificationCode: '',
  emailVerificationCodeError: '',

  // OTPVerification
  OTPCode: '',
  OTPCodeErrorMsg: '',

  // TwoFactorAuth (MFA)
  MFACode: '',
  MFACodeErrMSg: '',
  defaultMethod: '',
  availableMethod: [],
  methodEnum: [],
  userSms: '',
  userEmail: '',
  choseMethod: '',
  isChooseAnotherMethod: false,

  // Countdown & Verify (OTP/MFA)
  counter: null,
  isCountDowning: false,
  countDownSec: 0,
  isVerifying: false,
  isCodeSentFail: false,
};
